import * as React from "react";
import authModule from "../../../../../../../utilities/AuthModule";
import { LanguageContext } from "../../../../../../../utilities/LocalizationModule";
import { ITaxonomySelection } from "../../../../../interfaces/advancedSearch/ITaxonomySelection";
import { SharepointSpServices } from "../../../../../services/SharepointSpServices";
import { TaxonomyPicker } from "../../../../inputs/taxonomyPicker/TaxonomyPicker";
import { IPickerTerm } from "../../../../inputs/taxonomyPicker/ITermPicker";

interface ITermSetDetails {
  termsetNameOrID: string;
  defaultTerms: IPickerTerm[]
}

const TaxonomyPickerInput: React.FunctionComponent<ITaxonomySelection> = props => {
  const languageStrings = React.useContext(LanguageContext);
  const [termSetDetails, setTermSetDetails] = React.useState<ITermSetDetails>(null);

  const handleOnChange = (items: any) => {
    props.handleValueChange(props.searchInputData?.index, items.map(item => item.name));
  };

  const taxonomyProps = {
    allowMultipleSelections: props.itemLimit > 1,
    termsetNameOrID: undefined,
    panelTitle: languageStrings.SelectTerm,
    label: props.displayName,
    context: { webUrl: props.webUrl, regionalLocalId: 0 },
    onChange: handleOnChange,
    isTermSetSelectable: false,
    useSessionStorage: true,
    initialValues: undefined
  };

  React.useEffect(() => {
    const setupAsyncWrapper = async () => {
      const accessToken = await authModule.getSharePointAccessToken();
      const sharepointSpService = new SharepointSpServices(props.webUrl, accessToken);
      const termSetResult: any = await sharepointSpService.getTaxonomyTermSet(props.sharepointListId, props.internalName);
      if (termSetResult?.TermSetId) {
        setTermSetDetails({ termsetNameOrID: termSetResult.TermSetId, defaultTerms: null });
      }
    };
    setupAsyncWrapper();
  }, []);

  const getTaxonomyProps = () => {
    return { ...taxonomyProps, termsetNameOrID: termSetDetails.termsetNameOrID, initialValues: termSetDetails.defaultTerms };
  }

  const taxonomyPicker = (termSetDetails?.termsetNameOrID &&
    <div style={{ width: "100%" }}>
      <TaxonomyPicker {...getTaxonomyProps()} />
    </div>)

  return (
    <>{taxonomyPicker}</>
  );
};

export default TaxonomyPickerInput;
